import React from "react";
import { Panel } from "components/panels";
import TwoColumnLayout from "layout/TwoColumnLayout";

interface ICalendarFeedHelpLayoutProps extends React.PropsWithChildren {
  sidebar: React.ReactNode;
}

export const ICalendarHelpLayout = (props: ICalendarFeedHelpLayoutProps) => {
  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn cellClasses="icalendar-feed-help-content">
      {props.children}
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn cellClasses="icalendar-feed-help-navigation">
      <Panel style={{ marginTop: 0 }} panelClassName="s1_related-feature-panel">
        {props.sidebar}
      </Panel>
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}